import request from '@/utils/request'
const serivceBase = require('@/config/serviceConfig')

// 混合套餐兑换码异步兑换大概率会改成通用
export function syncVerify(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/verifyV2`,
    method: 'post',
    data
  })
}
// 发送短信
export function sendVerifyCode(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/sendVerifyCodeV2`,
    method: 'post',
    data
  })
}
// 查询兑换结果
export function queryVerifyRes(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/queryVerifyRes`,
    method: 'post',
    data
  })
}
// 混合套餐兑换码链接-校验接口  T1006014 混合套餐兑换码改造，支持链接形式
export function checkForMixComboLink(data) {
  return request({
    url: `${serivceBase.IMS}/redeemCodeStream/checkForMixComboLink`,
    method: 'post',
    data
  })
}
